/**
 * Hub card navigation (specs/competitions-hub-client AC-6.1).
 * WC keeps its dedicated experience (doubles as its archive); other competitions
 * route into /app/competition/[id] while LIVE or UPCOMING. Finished non-WC
 * competitions have no archive screen yet (Slice 3) — inert card, no dead taps.
 */

import type { CompetitionSummary } from '../types/competitions.types';
import { competitionBasePath } from './competitionRoutes.helper';

export const WORLD_CUP_HREF = '/app/worldcup';

export function getCompetitionHref(
  competition: Pick<CompetitionSummary, 'id' | 'lifecycle'>,
  worldCupId: string,
): string | null {
  if (competition.id === worldCupId) return WORLD_CUP_HREF;
  // Finished pools open the same shell read-only: the final leaderboard and squad
  // results stay browsable, and picks are locked per-match server-side anyway.
  return competitionBasePath(competition.id);
}
